(function(algolia) {
  'use strict';

  var sort_order_base = algolia.config.index_prefix + 'products';

  // Helpers
  function hasSortValue(list, value) {
    if (!list || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].value === value) return true;
    }
    return false;
  }

  function isActive(flag) {
    return flag === true || flag === '1';
  }

  // -----------------------------
  // SEARCH sort orders (unchanged)
  // -----------------------------
  algolia.sortOrders = [
    { value: sort_order_base, label: '' + algolia.translations.relevance },
  ];

  algolia.config.sort_orders.forEach(function(sort_order) {
    if (sort_order.asc && isActive(sort_order.asc.active)) {
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_asc',
        label: sort_order.asc.title,
      });
    }

    if (sort_order.desc && isActive(sort_order.desc.active)) {
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_desc',
        label: sort_order.desc.title,
      });
    }
  });

  // ---------------------------------------------------------
  // COLLECTION sort orders (updated to include Name A–Z / Z–A)
  // ---------------------------------------------------------

  // try to fetch sort orders for current collection or fallback to collections default
  var collection_sort_orders =
    algolia.current_collection_id &&
    algolia.config.collection_sort_orders &&
    algolia.config.collection_sort_orders[algolia.current_collection_id]
      ? algolia.config.collection_sort_orders[algolia.current_collection_id]
      : algolia.config.collection_sort_orders &&
        algolia.config.collection_sort_orders.default;

  if (collection_sort_orders) {
    algolia.collectionSortOrders = [
      { value: sort_order_base, label: '' + algolia.translations.relevance },
    ];

    // Build dropdown items from per-collection config first (existing behavior)
    collection_sort_orders.forEach(function(sort_order) {
      if (sort_order.asc && isActive(sort_order.asc.active)) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_asc',
          label: sort_order.asc.title,
        });
      }

      if (sort_order.desc && isActive(sort_order.desc.active)) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_desc',
          label: sort_order.desc.title,
        });
      }
    });

    // NEW: Ensure "Name A–Z" and "Name Z–A" appear on collection pages when enabled globally.
    // Some legacy themes rely on per-collection sort metadata (collection_sort_orders) which can omit
    // title-based sorts unless "Sync Metafields" has been run. We use the global sort_orders config
    // as the source of truth for whether title sorts are enabled.
    var title_asc_value = sort_order_base + '_title_asc';
    var title_desc_value = sort_order_base + '_title_desc';
    var global_title_asc_active = false;
    var global_title_desc_active = false;

    if (algolia.config && Array.isArray(algolia.config.sort_orders)) {
      algolia.config.sort_orders.forEach(function(so) {
        if (!so || so.key !== 'title') return;
        if (so.asc && isActive(so.asc.active)) global_title_asc_active = true;
        if (so.desc && isActive(so.desc.active)) global_title_desc_active = true;
      });
    }

    if (global_title_asc_active && !hasSortValue(algolia.collectionSortOrders, title_asc_value)) {
      algolia.collectionSortOrders.push({
        value: title_asc_value,
        label: 'Name A-Z',
      });
    }

    if (global_title_desc_active && !hasSortValue(algolia.collectionSortOrders, title_desc_value)) {
      algolia.collectionSortOrders.push({
        value: title_desc_value,
        label: 'Name Z-A',
      });
    }
  }
})(window.algoliaShopify);
